import Tags from '~/src/molecules/Tags/';
import React from 'react';
import useSelectedPack from './useSelectedPack';
import tw from 'twin.macro';

const Sponsor = ({ ...rest }) => {
  const { additionalAttributes = {} } = useSelectedPack();

  const sponsoredTag = additionalAttributes?.info?.find((attr) => attr?.type === 'sponsored');
  const newTag = additionalAttributes?.info?.find((attr) => attr?.type === 'new');

  if (sponsoredTag === undefined && newTag === undefined) return <></>;

  if (sponsoredTag !== undefined && newTag !== undefined) {
    const label = sponsoredTag?.label?.split('');
    label[0] = label?.[0]?.toUpperCase();
    return (
      <Tags css={tw`h-full`} variant={sponsoredTag?.label} {...rest}>
        {label.join('')}
      </Tags>
    );
  }
  if (sponsoredTag) {
    const label = sponsoredTag?.label?.split('');
    label[0] = label?.[0]?.toUpperCase();
    return (
      <Tags css={tw`h-full`} variant={sponsoredTag?.label} {...rest}>
        {label.join('')}
      </Tags>
    );
  }
  if (newTag) {
    return (
      <Tags css={tw`h-full`} variant={newTag?.label} {...rest}>
        {newTag?.label}
      </Tags>
    );
  }
};

export default Sponsor;
